// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { UserIconEl } from 'common/widgets/user-icon';
import { TEXT_HIGHLIGHT_THEME, TextHighlightEl } from 'common/components/text-highlight';
import { SelectTheme } from 'common/components/select/constants';
import { SelectEl } from 'common/components/select';
import { PublicDashboardLinkRow, ShareOptionsLocation } from 'common/widgets/sharing/modal/types';
import { truncate } from 'common/util/string';
import { IconSizeType } from 'common/constants';
export const getWorkspaceName = _ref => {
  let {
    dataView
  } = _ref;
  return <span data-sentry-component="getWorkspaceName" data-sentry-source-file="helpers.tsx">{truncate(dataView, 20)}</span>;
};
export const getPublicDashboardLinkEnabled = (row: PublicDashboardLinkRow) => {
  return <div data-sentry-component="getPublicDashboardLinkEnabled" data-sentry-source-file="helpers.tsx">
      <p sel='.public-dashboard-created'>{row.createdDate}</p>
      <p sel='.public-dashboard-creator'>by {row.creator}</p>
    </div>;
};
const getUserIconEl = (id: number, name: string, email: string) => <UserIconEl sel='.mp-user-icon' attrs={{
  id,
  name,
  email,
  'disable-tooltip': true,
  size: IconSizeType.Medium
}} data-sentry-element="UserIconEl" data-sentry-component="getUserIconEl" data-sentry-source-file="helpers.tsx" />;
export const GetOwnerListItem = helpers => {
  const owner = helpers.getEntityOwner();
  const userIcon = getUserIconEl(owner.id, owner.name, owner.email);
  const displayEmail = helpers.getShareGrantEmail(owner.email);
  return <li sel='.share-list-item' attrs={{
    elref: "owner"
  }} data-sentry-component="GetOwnerListItem" data-sentry-source-file="helpers.tsx">
      {userIcon}
      <div sel='.display'>
        <>
          <div sel='.name'>{owner.formattedName}</div>
          <div sel='.subtitle'>{displayEmail}</div>
        </>
      </div>
      <div sel='.controls'>
        <div sel='.creator-label'>{helpers.t("mixology.user-access.creator")}</div>
      </div>
    </li>;
};
export const ShareSection = (type: `People` | `Teams`, items, helpers, disabled) => {
  let peopleTitle;
  if (type === "People" && helpers.entityHasOwner()) {
    peopleTitle = GetOwnerListItem(helpers);
  }
  let title = "";
  if (type === "People") {
    title = helpers.t("components.sharing.people");
  } else if (type === "Teams") {
    title = helpers.t("components.sharing.teams");
  }
  if (items || peopleTitle) {
    return <div sel='.share-section' attrs={{
      elref: "shareSection".concat(type)
    }}>
        <header sel='.header'>{title}</header>
        <ul sel='.share-list'>
          {peopleTitle}
          {items === null || items === void 0 ? void 0 : items.map(share => {
          // in editor mode, when a user adds a new member or team we need to hydrate metadata
          // using data from granted_users/granted_teams endpoints. In case of disabled state,
          // we avoid this hydration since it has all metadata needed from shared-entities endpoint.
          const shareGrant = disabled ? share : helpers.existingShares.getShareItem(share);
          let subtitleContent: string;
          if (type === "People") {
            subtitleContent = helpers.getShareGrantEmail(shareGrant.email);
          } else if (!disabled) {
            subtitleContent = helpers.t("components.sharing.members", {
              count: helpers.existingShares.getTeamMembersCount(shareGrant)
            });
          }
          return <li sel='.share-list-item' attrs={{
            elref: "share_".concat(shareGrant.id)
          }}>
                {getUserIconEl(shareGrant.id, helpers.getShareGrantDisplayName(shareGrant), shareGrant.email)}
                <div sel='.display'>
                  <div sel='.name-wrapper'>
                    <div sel='.name'>{helpers.getShareGrantDisplayName(shareGrant)}</div>
                    {helpers.getShareGrantStatusText(shareGrant.grantStatus) && <TextHighlightEl sel='.mp-text-highlight' attrs={{
                  theme: TEXT_HIGHLIGHT_THEME.SUCCESS,
                  text: helpers.getShareGrantStatusText(shareGrant.grantStatus)
                }} />}
                  </div>
                  {subtitleContent && <div sel='.subtitle'>{subtitleContent}</div>}
                </div>
                <div sel='.controls'>
                  <SelectEl sel='.share-level' attrs={{
                'disable-search': true,
                'menu-width': 120,
                theme: SelectTheme.Tertiary,
                'always-show-caret': true,
                'selected-option': share.canEdit || !helpers.isSharingEnabledForProject() ? helpers.t("mixology.user-access.editor") : helpers.t("mixology.user-access.viewer"),
                elref: "selectShareLevel_".concat(shareGrant.id),
                'use-fixed-dropmenu-pos': true,
                disabled
              }} params={{
                sections: helpers.getSelectOptions(ShareOptionsLocation.UserOrTeamShare)
              }} on={{
                change: ev => helpers.existingShares.handleShareLevelSelectChange(ev, shareGrant)
              }} />
                </div>
              </li>;
        })}
        </ul>
      </div>;
  }
  return null;
};